// document.addEventListener('DOMContentLoaded', function () {  
//   // Select all radio inputs  
//   const variantInputs = document.querySelectorAll('input[type="radio"]');  
//   const badgeElement = document.getElementById('VariantBadge');  

//   variantInputs.forEach(function (input) {  
//     input.addEventListener('change', function () {  
//       // Get the variant title from the data attribute  
//       const variantTitle = this.dataset.variantTitle;  

//       if (badgeElement && variantTitle) {  
//         // Update the badge with the selected variant's title  
//         badgeElement.textContent = variantTitle;  
//       }  
//     });  
//   });  
// });  



// document.addEventListener('DOMContentLoaded', function () {  
//   // Select all radio inputs  
//   const variantInputs = document.querySelectorAll('input[type="radio"]');  
//   const badgeElement = document.getElementById('VariantBadge');  

//   function selectVariant(input) {
//     if (!input) return; // Ensure input exists

//     // Remove "selected" class from all variant items  
//     document.querySelectorAll('.variant-item').forEach(item => {
//       item.classList.remove('selected');
//     });

//     // Add "selected" class to the parent variant-item of the selected radio
//     const parentVariant = input.closest('.variant-item');  
//     if (parentVariant) {  
//       parentVariant.classList.add('selected');  
//     }  

//     // Update the badge with the selected variant's title  
//     const variantTitle = input.dataset.variantTitle;  
//     if (badgeElement && variantTitle) {  
//       badgeElement.textContent = variantTitle;  
//     }  
//   }

//   // Select the first available variant on page load
//   if (variantInputs.length > 0) {
//     variantInputs[0].checked = true;  // Mark first radio as checked
//     selectVariant(variantInputs[0]);  // Apply selection
//   }

//   // Listen for change events on the radio buttons
//   variantInputs.forEach(function (input) {  
//     input.addEventListener('change', function () {  
//       selectVariant(this);  
//     });  
//   });  
// });







  document.addEventListener("DOMContentLoaded", function () {
    const variantItems = document.querySelectorAll(".variant-item");
    
    variantItems.forEach((item) => {
      const input = item.querySelector("input[type='radio']");
      
      if (input.checked) {
        item.classList.add("selected");
      }
      
      input.addEventListener("change", function () {
        variantItems.forEach((el) => el.classList.remove("selected"));
        item.classList.add("selected");
      });
    });
  });






